import { put } from 'redux-saga/effects';
import { ALL_FOLDER_ID, SCRAPS_FOLDER_ID } from '@wix/da-url';
import { unsetCurrentSubfolderId, initGallectionStream, initGallectionDeviationStream } from '../actions';
function* setCurrentFolderIdHandler(action) {
    const folderId = action.payload;
    yield put(unsetCurrentSubfolderId());
    yield put(initGallectionDeviationStream());
    // "All" and Scraps cannot have subfolders so we don't need to fetch them
    if (folderId !== ALL_FOLDER_ID && folderId !== SCRAPS_FOLDER_ID) {
        yield put(initGallectionStream({
            folderId
        }));
    }
}
export default setCurrentFolderIdHandler;
